import StepConfig from 'libs/fields-manager/src/shared/stores/models/StepConfig';
import { RequestObjectExtraFieldsDataType } from 'libs/fields-manager/src/shared/types/zodSchemaTypes';

class ApplicationSectionFormModel {
  formDetails: any;
  formValidationSchema: any;
  formsRequestObjectKeys: RequestObjectExtraFieldsDataType;
  onSubmitRedirectionUrl?: string;
  formConfig: any;

  currentDateTime: Date = new Date();

  constructor(sectionFormConfig: any) {
    this.currentDateTime =
      sectionFormConfig?.current_datetime &&
      new Date(sectionFormConfig?.current_datetime);
    const formFieldConfig =
      sectionFormConfig?.form_field_config &&
      JSON.parse(sectionFormConfig?.form_field_config);
    const formConfig =
      sectionFormConfig?.form_config &&
      JSON.parse(sectionFormConfig?.form_config);
    let formSectionConfigModel = null;
    let formsRequestObjectKeys = [];
    let formValidationSchema =
      sectionFormConfig?.form_validation_config &&
      JSON.parse(sectionFormConfig?.form_validation_config);
    if (formFieldConfig) {
      formSectionConfigModel = new StepConfig(
        formFieldConfig.registration_form_details.step_details[0],
        null
      );
      formsRequestObjectKeys = formFieldConfig.request_object_extra_fields_data;
    }
    if (formConfig) {
      this.formConfig = formConfig;
    }
    this.formDetails = formSectionConfigModel;
    this.formsRequestObjectKeys = formsRequestObjectKeys;
    if (sectionFormConfig?.on_submit_redirect_url) {
      this.onSubmitRedirectionUrl = sectionFormConfig.on_submit_redirect_url;
    }
    if (formValidationSchema) {
      this.formValidationSchema = formValidationSchema;
    } else
      this.formValidationSchema = {
        schema: {}
      };
  }
}

export default ApplicationSectionFormModel;
